import type { BlockProps } from '../../types';
import { Layout } from '../../types';
import type { BuilderBlockProps } from '../Builder';

export function getSideMediaBlocks({
  blocks
}: {
  blocks: BuilderBlockProps['blocks'];
}) {
  const leftMediaBlocks: BlockProps[] = [];
  const rightMediaBlocks: BlockProps[] = [];

  const blocksWithoutMedia = blocks?.filter((block) => {
    if ('layout' in block && !!block.layout) {
      const isLeftMediaBlock = [Layout.LeftMedia, Layout.LeftBanner].includes(
        block.layout
      );
      const isRightMediaBlock = [
        Layout.RightMedia,
        Layout.RightBanner
      ].includes(block.layout);

      if (isLeftMediaBlock) {
        leftMediaBlocks.push(block);
        return false;
      }

      if (isRightMediaBlock) {
        rightMediaBlocks.push(block);
        return false;
      }
    }

    return true;
  });

  return {
    leftMediaBlocks,
    rightMediaBlocks,
    blocksWithoutMedia
  };
}
